import getOrganizationDetails from './getOrganizationDetails';
import getRoleDetails from './getRoleDetails';

export default (params) => [
  getOrganizationDetails(params),
  getRoleDetails(params),
];
